import React from "react";
import { NavLink } from "react-router-dom";
import logo from "../images/Logo.png";

// this component returns our navbar ultimately //

export const Navbar = () => {
  return (
    <div className="navbar">
      <div className="logo">
        <NavLink to="/">
          <img src={logo} alt="" width="120px" />
        </NavLink>
      </div>

      <div className="nav-links">
        <ul>
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "activenav" : "")}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/my-quizes"
              className={({ isActive }) => (isActive ? "activenav" : "")}
            >
              My Quizes
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};
